<div [hidden]="!active" class="dialog-modal">
  <div class="dialog-modal-body">
    <ng-content></ng-content>
  </div>
</div>
<div class="modal-background"></div>
